import { axiosInstance } from '../../api';
const BASE_PATH = '/customer_support';


//Submit customer support Ticket
export let submitCustomerTicket = async (values) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/submit_customer_support_ticket', {
            issue_area: values.issue_area,
            issue_description: values.issue_description
        })
        return value;
    } catch (error) {
        return error
    }
}